import ApplicationContentClient from '../common/ApplicationContentClient';

export class Dibels8ApplicationContentClient extends ApplicationContentClient {
    static ASSESSMENT = 'DIBELS8';

    static ASSESSMENT_SHORT_NAME = 'D8';

    static BASE_CONTENT_URL = '/dibels8-api/content/v1';

    static BASE_STATIC_CONTENT_URL = '/dibels8-assessment/static/content';

    static SECURE_CONTENT_URL = '/assessment-forms-api/v1/secure-forms';
}

export default Dibels8ApplicationContentClient;
